export default __webpack_public_path__ + "static/media/washer-toss.63d43e92.svg";